<script lang="ts">
import { defineComponent } from 'vue'

/**
 * Skeleton loader for game cards
 */
export default defineComponent({
  name: 'GameCardSkeleton',
  props: {
    count: {
      type: Number,
      default: 4,
    },
  },
})
</script>

<template>
  <div class="grid grid-cols-2 @md/main:grid-cols-3 @lg/main:grid-cols-4 gap-4">
    <div
      v-for="i in count"
      :key="i"
      class="animate-pulse rounded-lg border border-slate-300 bg-white"
    >
      <!-- Countdown bar with price -->
      <div class="flex h-10 bg-black">
        <div class="flex-1 p-2">
          <div class="h-6 w-24 rounded bg-slate-700" />
        </div>
        <div class="w-16 bg-slate-800" />
      </div>

      <!-- Image skeleton (5:4 aspect ratio) -->
      <div class="p-3 @sm/main:p-4 w-full">
        <div class="aspect-5/4 w-full rounded-md bg-slate-200" />
      </div>

      <!-- Progress bar skeleton -->
      <div class="h-2 w-full bg-slate-200" />

      <!-- Title skeleton -->
      <div class="px-3 @sm/main:px-4 pb-2 @sm/main:pb-3">
        <div class="mb-2 mt-2 h-5 w-3/4 rounded bg-slate-200" />
        <!-- Prize value skeleton -->
        <div class="h-4 w-1/2 rounded bg-slate-200" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
</style>
